import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { AuthorityNumbersSection } from '../components/sections/AuthorityNumbersSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { SolutionSection } from '../components/sections/SolutionSection';
import { BenefitsSection } from '../components/sections/BenefitsSection';
import { BonusSection } from '../components/sections/BonusSection';
import { ScarcitySection } from '../components/sections/ScarcitySection';
import { ValueAnchorSection } from '../components/sections/ValueAnchorSection';
import { PricingSection } from '../components/sections/PricingSection';
import { OfferBlock } from '../components/sections/OfferBlock';
import { TestimonialSection } from '../components/sections/TestimonialSection';
import { GuaranteeSection } from '../components/sections/GuaranteeSection';
import { FAQSection } from '../components/sections/FAQSection';
import { ClosingSection } from '../components/sections/ClosingSection';
import { FooterSection } from '../components/sections/FooterSection';
import { SocialProofPopup } from '../components/ui/SocialProofPopup';
export function LandingPage() {
  return <main className="min-h-screen bg-background-dark text-gray-300 font-body selection:bg-primary/30 selection:text-white" data-id="element-453">
      <HeroSection data-id="element-454" />
      <ProblemSection data-id="element-455" />
      <AuthorityNumbersSection data-id="element-456" />
      <SolutionSection data-id="element-457" />
      <BenefitsSection data-id="element-458" />
      <BonusSection data-id="element-459" />
      <ScarcitySection data-id="element-460" />
      <ValueAnchorSection data-id="element-461" />
      <PricingSection data-id="element-462" />
      <OfferBlock data-id="element-463" />
      <TestimonialSection data-id="element-464" />
      <GuaranteeSection data-id="element-465" />
      <FAQSection data-id="element-466" />
      <ClosingSection data-id="element-467" />
      <FooterSection data-id="element-468" />
      <SocialProofPopup data-id="element-469" />
    </main>;
}